const normalizePath = (pathname) => {
  const rawPath = pathname !== undefined ? pathname : (typeof window !== "undefined" ? window.location.pathname : "");
  // Strip query parameters and URL fragments
  const pathOnly = (rawPath || "").split(/[?#]/)[0];
  // Ensure path starts with a slash if not empty
  const formattedPath = pathOnly && !pathOnly.startsWith("/") ? `/${pathOnly}` : pathOnly;

  // Remove /ar or /en if exists
  const cleanPath = formattedPath.replace(/^\/(ar|en)(?=\/|$)/, "");

  // Check if root path
  const isRoot = cleanPath === "" || cleanPath === "/";

  // Remove trailing slashes from non-root paths only
  const normalizedPath = isRoot ? cleanPath : cleanPath.replace(/\/+$/, "");

  return {
    rawPath,
    formattedPath,
    cleanPath: normalizedPath,
    isRoot,
  };
};

export const getCanonicalUrl = (lang, pathname) => {
  const { formattedPath, cleanPath, isRoot } = normalizePath(pathname);

  if (cleanPath === "/404" || cleanPath === "/404.html" || formattedPath === "/404" || formattedPath === "/404.html") {
    return null;
  }

  if (isRoot) {
    if (lang === "ar") {
      return "https://tameen.om/ar";
    }
    return "https://tameen.om/";
  }

  if (lang === "ar") {
    return `https://tameen.om/ar${cleanPath}`;
  }

  return `https://tameen.om${cleanPath}`;
};

export const getAlternateUrls = (pathname) => {
  const { formattedPath, cleanPath, isRoot } = normalizePath(pathname);

  if (cleanPath === "/404" || cleanPath === "/404.html" || formattedPath === "/404" || formattedPath === "/404.html") {
    return null;
  }

  if (isRoot) {
    return {
      en: "https://tameen.om/",
      ar: "https://tameen.om/ar"
    };
  }

  return {
    en: `https://tameen.om${cleanPath}`,
    ar: `https://tameen.om/ar${cleanPath}`
  };
};

export const getLocalizedUrl = (path, lang) => {
  // Ensure path starts with a slash
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  if (lang === "ar") {
    return cleanPath === "/" ? "/ar" : `/ar${cleanPath.replace(/\/+$/, '')}`;
  }
  return cleanPath === "/" ? "/" : cleanPath.replace(/\/+$/, '');
};